module.exports = __webpack_public_path__ + "img/button-like.81eb9866.svg";